<div *ngIf="showMainPage" class="card">
  <h3>Application Details Aerial</h3>

  <form [formGroup]="myForm" (ngSubmit)="onSubmit()">



   
    <div class="form-group row">    
        <div class="form-group col-md-6">
        <label for="ada" class="lable-css">FCA ID:</label>
        <input type="text" id="ada" formControlName="adaId" name="ada" placeholder="Enter ADA ID" required />
      </div>
    </div>
    
    
    <div class="form-group row">
      <div class="form-group col-md-6">
        <app-upload-file [flowName]="flowName" (uploaded)="fileUploaded($event)"></app-upload-file>
        <!-- <label for="loc" class="lable-css">LOC ID:</label> -->
        <!-- <input type="file" id="loc" formControlName="locId" name="loc" placeholder="Upload LOC ID File" required /> -->
        <br />
        <p>Sample Location File :  <span (click)="downloadFile()">ADA_aerial.xlsx  (3BMT-05-53_Location.xlsx)</span></p>
      </div>
      <!-- <div class="form-group col-md-6">
        <label for="ada" class="lable-css">BTD Type:</label>
        <select formControlName="btd_type" id="btd_type" class="form-control">
          <option value="" selected>Select</option>
          <option value="1G">1G</option>
          <option value="10G">10G</option>
        </select>
      </div> -->
    </div>
    
    <button type="submit" [class]="myForm.invalid ? 'gray-button' : ''" [disabled]="myForm.invalid">
      Submit
    </button>
    
  </form>
  
</div>
<!-- DFN Component Called-->
<div *ngIf="showMessage" class="card">
        <app-message 
            [showMessage]="showMessage"
            [MessageToShow]="MessageToShow"
            url={{url}}
            msg={{msg}}
            filename={{filename}}
        >
        </app-message>
</div>
<!-- spinner Component Called-->
<div *ngIf="isLoading">
  <ngx-spinner type = "ball-scale-multiple"></ngx-spinner> 
</div>